import React from 'react'
import { useGetCurrentSettlementsQuery } from '../../../../api/asset-holders/assetHolderApi'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'
import { type AssetHolderIdProps } from '../../pages/DashboardHome'
import ProjectSettlementListItem from './ProjectSettlementListItem'

const PortfolioSettlementTabComponent: React.FC<AssetHolderIdProps> = ({ assetHolderId }: AssetHolderIdProps) => {
  const getSettlementApiResult = useGetCurrentSettlementsQuery({ assetHolderId })

  return (
    <>
      {getSettlementApiResult.isLoading && <LoadingComponent/>}
      {getSettlementApiResult.isError &&
        <ErrorComponent message={RtkQueryHelper.mapResponseError(getSettlementApiResult.error)}/>}

      {getSettlementApiResult.isSuccess && (
        getSettlementApiResult.data.map((settlement) => (
          <React.Fragment key={settlement.portfolioSettlementId}>
            <ProjectSettlementListItem settlement={settlement} assetHolderId={assetHolderId} />
          </React.Fragment>
        ))
      )}
    </>
  )
}

export default PortfolioSettlementTabComponent
